import { useQuery } from '@tanstack/react-query';

import { withError } from '@/react-tools/react-query';
import axios, { parseAxiosError } from '@/portainer/services/axios/axios';

import { TypedPolicies } from '../types';

import { queryKeys } from './query-keys';

export function usePolicies<T = TypedPolicies>(options?: {
  refetchInterval?: number;
  select?: (policies: TypedPolicies) => T;
}) {
  return useQuery({
    queryKey: queryKeys.list(),
    queryFn: getPolicies,
    refetchInterval: options?.refetchInterval,
    select: options?.select,
    ...withError('Unable to load policies'),
  });
}

async function getPolicies(): Promise<TypedPolicies> {
  try {
    const { data } = await axios.get<TypedPolicies>('/policies');
    return data;
  } catch (error) {
    throw parseAxiosError(error, 'Unable to retrieve policies');
  }
}
